if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.configuratorAddOns = document.querySelectorAll('[data-add-on-id]');
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('d-none');

      const config = fetchConfig(this.configuratorAddOns.length > 0 ? 'json' : 'javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      const formData = new FormData(this.form);

      if (this.configuratorAddOns.length > 0) {
        const items = [];
        this.configuratorAddOns.forEach((product) => {
          if (!product.checked) return;
          items.push({id: product.dataset.addOnId, quantity: 1});
        });
        items.push({id: formData.get('id'), quantity: 1});
        let body = {
          'items': items
        }
        

        config.body = JSON.stringify(body)
      
      } else {
          delete config.headers['Content-Type'];
          if (this.cart) {
            formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
            formData.append('sections_url', window.location.pathname);
          }
          config.body = formData;
      }
      this.cart ? this.cart.setActiveElement(document.activeElement) : null;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (!this.configuratorAddOns) {

            // GA4 Event
            dataLayer.push({
              ecommerce: null
            });
            dataLayer.push({
              event: "addToCartTrigger",
              ecommerce: {
                items: [
                  {
                    item_id: response.variant_id.toString(),
                    item_name: response.product_title.toString(),
                    affiliation: "Shopify Store",
                    currency: Shopify.currency.active.toString(),
                    discount: response.discount * .01,
                    item_brand: response.vendor.toString(),
                    price: response.price * .01,
                    quantity: response.quantity
                  }
                ]
              }
            });
            const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener('modalClosed', () => {
                  setTimeout(() => {
                    this.cart.renderContents(response)
                  });
                }, {
                  once: true
                });
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
          }

          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('d-none');
            soldOutMessage.classList.remove('d-none');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
           const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
          this.error = false;
          
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if (this.configuratorAddOns.length > 0) {
              window.location.href = window.routes.cart_url;
          }
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('d-none');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
